module.exports = __webpack_public_path__ + "static/media/FeaturedIn_Mobile_SV.4547c8a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FeaturedIn_Mobile_SV.png
// module id = 1050
// module chunks = 0